import { Link } from "react-router-dom";

// Keep each destination's content and route together so the Explore cards can
// be reordered or expanded without duplicating their presentation markup.
const exploreDestinations = [
  {
    title: "Lore Vault",
    image: "/media/images/lore_vault.avif",
    imageAlt: "A glimpse into the Lore Vault",
    to: "/lore_vault",
  },
  {
    title: "Author's Note",
    image: "/media/images/mahesh_thakur.avif",
    imageAlt: "Mahesh Thakur, author of The Oath of the Unhuan",
    to: "/author",
  },
  {
    title: "Book Trailer",
    image: "/media/images/desktop_background.jpg",
    imageAlt: "A cinematic scene from The Oath of the Unhuan",
    to: "/book",
  },
];

/**
 * Presents the three main paths beyond the book purchase Hero as a full,
 * responsive landing-page view.
 */
export default function OathboundExplore() {
  return (
    <section
      id="explore"
      className="oathbound-explore"
      aria-labelledby="oathbound-explore-title"
    >
      <h2 id="oathbound-explore-title">Enter the World of The Pehuans</h2>

      <div className="oathbound-explore-grid">
        {exploreDestinations.map((destination) => (
          <article className="oathbound-explore-item" key={destination.title}>
            <div className="oathbound-explore-card">
              <img
                src={destination.image}
                alt={destination.imageAlt}
                width="1600"
                height="900"
                loading="lazy"
                decoding="async"
              />
              <div className="oathbound-explore-tint" aria-hidden="true" />
              <Link
                className="oathbound-explore-enter"
                to={destination.to}
                aria-label={`Enter ${destination.title}`}
              >
                Enter
              </Link>
            </div>
            <h3>{destination.title}</h3>
          </article>
        ))}
      </div>
    </section>
  );
}
